/*
 * @Author: Chao Yang
 * @Date: 2020-11-16 07:12:42
 * @LastEditor: Chao Yang
 * @LastEditTime: 2021-07-15 01:20:04
 */
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
